/**
 * Helper to determine theme with auto-detection for Indonesian Time (WIB UTC+7)
 * 6 PM (18:00) to 6 AM (06:00) -> Dark mode
 * 6 AM (06:00) to 6 PM (18:00) -> Light mode
 */
export const getAutoTheme = () => {
  const savedTheme = localStorage.getItem("landing-theme");
  if (savedTheme === "dark" || savedTheme === "light") {
    return savedTheme;
  }
  
  // Calculate Indonesian WIB time (UTC+7)
  const now = new Date();
  const utcHours = now.getUTCHours();
  const wibHours = (utcHours + 7) % 24;
  
  // 6 PM (18:00) to 6 AM (06:00) is Dark Mode
  if (wibHours >= 18 || wibHours < 6) {
    return "dark";
  }
  return "light";
};
